import React, { useState } from 'react'
import {
  Box,
  Button,
  CircularProgress,
  Divider,
  Grid,
  Paper,
  Tooltip,
  Typography,
  tooltipClasses,
  useMediaQuery
} from '@mui/material'
import { styled } from '@mui/material/styles'
import { useTheme } from '@mui/material/styles'
import { TextBold, TextRegular, TextSemiBold } from './TextStyling'
import DoDisturbIcon from '@mui/icons-material/DoDisturb'
import { useNavigate, useLocation, Link } from 'react-router-dom'
import appassets from '../utils/appassets'
import WorklistModal from '../screens/recruiter/jobs/WorklistModal'
import CandidateFormModal from '../screens/recruiter/jobs/CandidateFormModal'
import moment from 'moment'
import { currencySymbol } from '../utils/AppConstants'
import { colorWithOpacity, formatNumber, isEmpty } from '../utils/AppHelper'
import ImageComponent from './ImageComponent'
import NoRecordFound from './NoRecordFound'
import TotalReferralsModal from '../screens/recruiter/jobs/TotalReferralsModal'
import SendIcon from '@mui/icons-material/Send'
import { ENV } from '../ENV'
import GroupIcon from '@mui/icons-material/Group'

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1],
    fontSize: 11
  }
}))

function JobPost(props) {
  const { onReload } = props
  const navigate = useNavigate()
  const location = useLocation()
  const theme = useTheme()

  const matches = useMediaQuery(theme.breakpoints.down('sm')) // Detect small screens

  const [openTotalReferral, setOpenTotalReferral] = useState({
    open: false
  })

  const [isOpen, setIsOpen] = useState({})

  const handleIsOpen = (id, field) => {
    setIsOpen(prevState => ({
      ...prevState,
      [id]: {
        jobDescription: false,
        Skills: false,
        employerId: false,
        preScreenQuestions: false,
        jobTitle: false,
        workLocationInfo: false,
        [field]: !prevState[id]?.[field]
      }
    }))
  }

  const [previewModal, setPreviewModal] = useState()

  const [previewCandidateModal, setPreviewCandidateModal] = useState({
    open: false
  })

  const getJobInsights = item => {
    var jobInsightsData = [
      {
        id: 1,
        title: 'Name:',
        value: `${item.adminFirstName !== null ? item.adminFirstName : 'NA'} ${item.adminLastName !== null ? item.adminLastName : ''
          }`
      },
      {
        id: 2,
        title: 'Email:',
        value: `${item.adminEmail !== null ? item.adminEmail : 'NA'}`
      },
      {
        id: 3,
        title: 'Phone:',
        value: `${item.adminPhone !== null ? item.adminPhone : 'NA'}`
      },
      { id: 4, title: 'Total positions:', value: `${item.totalPositions}` }
      // {
      //   id: 5,
      //   title: 'Additional information:',
      //   value: `NA`
      // },
      // { id: 6, title: 'Interview Process:', value: `NA` },
      // {
      //   id: 7,
      //   title: 'Company Background / Culture:',
      //   value: `NA`
      // }
    ]

    return jobInsightsData.map(jd => (
      <Grid item xs={12} key={jd.id}>
        <TextBold
          style={{
            fontSize: '16px',
            lineHeight: '24px',
            color: theme.palette.text.secondary
          }}
        >
          {jd.title}
        </TextBold>
        <TextRegular
          style={{
            fontSize: '16px',
            lineHeight: '24px',
            color: theme.palette.text.secondary
          }}
        >
          {' '}
          {jd.value}
        </TextRegular>
      </Grid>
    ))
  }

  const getJobDescriptionData = item => {
    var jobDescriptionData = [
      {
        id: 1,
        title: 'Experience level:',
        value: `${item.experienceLevelName}`
      },
      // {
      //   id: 2,
      //   title: 'Experience required:',
      //   value: `${item.requiredExpYear} year ${
      //     item.requiredExpMonth > 0 ? item.requiredExpMonth : ''
      //   } ${item.requiredExpMonth > 0 ? 'month' : ''}`
      // },
      // { id: 3, title: 'Education level:', value: `${item.educationLevelName}` },
      { id: 4, title: 'Job function:', value: `${item.jobFunction}` },
      // { id: 5, title: 'Job industry:', value: `${item.jobIndustry}` },
      // {
      //   id: 6,
      //   title: 'Annual compensation:',
      //   value: `${item.jobCompensationAmountMin} - ${item.jobCompensationAmountMax}`
      // },
      { id: 7, title: 'Total positions:', value: `${item.totalPositions}` },
      // {
      //   id: 8,
      //   title: 'Relocation assistance:',
      //   value: `${item.relocationAssistance}`
      // },
      {
        id: 9,
        title: 'CTC:',
        value: `${item.budget}`
      },
      {
        id: 10,
        title: 'Salary:',
        value: `${item.salary}`
      }
    ]

    return jobDescriptionData.map(jd => (
      <Grid item xs={12} key={jd.id}>
        <TextBold
          style={{
            fontSize: '16px',
            lineHeight: '24px',
            color: theme.palette.text.secondary
          }}
        >
          {jd.title}
        </TextBold>
        <TextRegular
          style={{
            fontSize: '16px',
            lineHeight: '24px',
            color: theme.palette.text.secondary
          }}
        >
          {' '}
          {jd.value}
        </TextRegular>
      </Grid>
    ))
  }
  const getSkillsData = item => {
    var SkillsData = [
      {
        id: 1,
        title: 'Skills Required:',
        value: `${item.skillRequired}`
      },

    ]

    return SkillsData.map(jd => (
      <Grid item xs={12} key={jd.id}>
        <TextBold
          style={{
            fontSize: '16px',
            lineHeight: '24px',
            color: theme.palette.text.secondary
          }}
        >
          {jd.title}
        </TextBold>
        <TextRegular
          style={{
            fontSize: '16px',
            lineHeight: '24px',
            textTransform: 'capitalize',
            color: theme.palette.text.secondary
          }}
        >
          {' '}
          {jd.value}
        </TextRegular>
      </Grid>
    ))
  }
  return (
    <Grid container>
      {props?.loading ? (
        <Grid
          container
          spacing={2}
          direction={'column'}
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '70vh',
            width: '100%'
          }}
        >
          <Grid item>
            <CircularProgress />
          </Grid>
          <Grid item>
            <TextRegular>{props.loadingMessage}</TextRegular>
          </Grid>
        </Grid>
      ) : props?.data?.length > 0 ? (
        props?.data?.map(item => (
          <Grid
            key={item.jobId}
            item
            xs={12}
            style={{
              display: 'flex',
              flexDirection: 'column',
              marginBottom: '16px',
              padding: '0px'
            }}
          >
            <Paper
              elevation={0}
              sx={{
                padding: '24px',
                flexGrow: 1,
                borderRadius: '16px'
              }}
            >
              <Grid container spacing={2} style={{ marginBottom: '0px' }}>
                <Grid item xs={matches ? 12 : 9} container spacing={1}>
                  <Grid container spacing={0} style={{ marginLeft: '4px' }}>
                    <Grid item xs={12} style={{ display: 'flex', alignItems: 'center' }}>
                      <Grid item xs={12} sm container>
                        <Grid
                          item
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            border: `1px solid ${theme.palette.border.main}`,
                            width: '57px',
                            height: '56px',
                            borderRadius: '16px',
                            marginTop: '8px',
                            overflow: 'hidden',
                            objectFit: 'contain',
                            alignItems: 'center'
                          }}
                        >
                          <ImageComponent
                            alt='company logo'
                            src={item.profilePicture}
                            style={{ width: '100%' }}
                          />
                        </Grid>
                        <Grid
                          item
                          xs={10}
                          style={{
                            paddingLeft: matches ? 0 : '16px',
                            marginTop: '8px'
                          }}
                        >
                          <Grid item xs={12} style={{ display: 'flex', marginTop: '1px' }}>
                            <TextBold
                              style={{
                                fontSize: '18px',
                                lineHeight: '24px',
                                textTransform: 'capitalize'
                              }}
                            >
                              {item.jobTitle}
                            </TextBold>
                          </Grid>

                          <Grid
                            item
                            xs={12}
                            style={{
                              marginTop: '8px',
                              marginLeft: '5px'
                            }}
                          >
                            <TextSemiBold
                              style={{
                                cursor: 'pointer',
                                lineHeight: '24px',
                                color: theme.palette.primary.main
                              }}
                              onClick={() => {
                                if (
                                  location.pathname !== '/recruiter/newcompany'
                                ) {
                                  navigate('/recruiter/newcompany', {
                                    state: item
                                  })
                                }
                              }}
                            >
                              {matches ? (
                                <>{item.companyname}</>
                              ) : (
                                <>
                                  {item?.companyname}
                                  {/* - {item?.city},{' '}
                                  {item.countryName} */}
                                </>
                              )}
                            </TextSemiBold>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid
                      item
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginRight: '10px',
                        marginTop: '12px'
                      }}
                    >
                      <img
                        src={`${appassets.location}`}
                        alt='location'
                        style={{ marginRight: '8px' }}
                      />
                      <TextRegular
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          fontSize: '16px',
                          lineHeight: '24px',
                          color: theme.palette.text.secondary,
                          paddingRight: matches ? 0 : '16px',
                          textTransform:"capitalize"
                        }}
                      >
                        {item.city} , {item.state}, {item.countryName}
                      </TextRegular>
                      <span
                        style={{
                          marginLeft: '8px',
                          marginRight: '8px',
                          color: theme.palette.text.disabled, // or theme.palette.text.secondary
                          fontSize: '22px',
                          lineHeight: '24px'
                        }}
                      >
                        |
                      </span>
                    </Grid>

                    <Grid
                      item
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginRight: '10px',
                        marginTop: '12px'
                      }}
                    >

                      <img
                        src={`${appassets.suitcase}`}
                        alt='suitcase'
                        style={{ marginRight: '8px' }}
                      />
                      <TextRegular
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          fontSize: '16px',
                          lineHeight: '24px',
                          color: theme.palette.text.secondary,
                          paddingRight: matches ? 0 : '16px'
                        }}
                      >
                        {item.jobTypeName}
                      </TextRegular>
                        <span
                        style={{
                          marginLeft: '8px',
                          marginRight: '8px',
                          color: theme.palette.text.disabled, // or theme.palette.text.secondary
                          fontSize: '22px',
                          lineHeight: '24px'
                        }}
                      >
                        |
                      </span>
                    </Grid>
                    <Grid
                      item
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginRight: '10px',
                        marginTop: '12px'
                      }}
                    >
                      <img
                        src={`${appassets.time}`}
                        alt='time'
                        style={{ marginRight: '8px' }}
                      />
                      <TextRegular
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          fontSize: '16px',
                          lineHeight: '24px',
                          color: theme.palette.text.secondary,
                          paddingRight: matches ? 0 : '16px'
                        }}
                      >
                        {moment(item?.createdAt).fromNow()}
                      </TextRegular>
                        <span
                        style={{
                          marginLeft: '8px',
                          marginRight: '8px',
                          color: theme.palette.text.disabled, // or theme.palette.text.secondary
                          fontSize: '22px',
                          lineHeight: '24px'
                        }}
                      >
                        |
                      </span>
                    </Grid>

                    <LightTooltip
                      placement='top'
                      title='Total applications applied to this job.'
                    >
                      <Grid
                        item
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          marginRight: '10px',
                          marginTop: '12px',
                          cursor: 'pointer'
                        }}
                      >
                        <GroupIcon
                          style={{ color: theme.palette.text.secondary }}
                        />
                        <TextRegular
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            fontSize: '16px',
                            lineHeight: '24px',
                            color: theme.palette.text.secondary,
                            paddingRight: matches ? 0 : '16px',
                            paddingLeft: '8px'
                          }}
                        >
                          {item.candidatePipeline.totalApplication}{' '}
                          {item.candidatePipeline.totalApplication > 1 ? (
                            <>applicants</>
                          ) : (
                            <>applicant</>
                          )}
                        </TextRegular>
                          <span
                        style={{
                          marginLeft: '8px',
                          marginRight: '8px',
                          color: theme.palette.text.disabled, // or theme.palette.text.secondary
                          fontSize: '22px',
                          lineHeight: '24px'
                        }}
                      >
                        |
                      </span>
                      </Grid>
                    </LightTooltip>
                    <Grid
                      item
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginRight: '10px',
                        marginTop: '12px'
                      }}
                    >
                      <TextRegular
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          fontSize: '16px',
                          lineHeight: '24px',
                          color: theme.palette.text.secondary,
                          paddingRight: matches ? 0 : '16px'
                        }}
                      >
                        Total Number of Position:{item.totalPositions}
                      </TextRegular>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      style={{
                        display: 'none',
                        marginRight: '10px',
                        marginTop: '12px',
                        alignItems: 'flex-start',
                        width: '100%'
                      }}
                    >
                      <img
                        src={`${appassets.skill}`}
                        alt='skills'
                        style={{
                          marginRight: '6px',
                          width: '16px',
                          marginTop: '4px'
                        }}
                      />
                      <TextRegular
                        style={{
                          display: 'flex',
                          fontSize: '16px',
                          lineHeight: '24px',
                          color: theme.palette.text.secondary,
                          paddingRight: matches ? '6px' : '8px',
                          marginTop: '1px'
                        }}
                      >
                        Skills:
                      </TextRegular>
                      <TextRegular
                        style={{
                          fontSize: '16px',
                          lineHeight: '24px',
                          color: theme.palette.text.secondary,
                          paddingRight: 0,
                          flexWrap: 'wrap',
                          display: 'flex'
                        }}
                      >
                        {item.skillRequired
                          .split(',')
                          .map(skill => skill.trim())
                          .map((skill, index, arr) => {
                            return (
                              <span
                                key={index}
                                style={{
                                  width: 'fit-content',
                                  textTransform: [
                                    /^[A-Z]+$/.test(skill),
                                    /[A-Z]/.test(skill.slice(1))
                                  ].some(e => e)
                                    ? 'none'
                                    : 'capitalize'
                                }}
                              >
                                {skill}
                                {index < arr.length - 1 && ','}&nbsp;
                              </span>
                            )
                          })}
                      </TextRegular>
                    </Grid>

                    {matches ? (
                      <>
                        <Grid item xs={12} style={{ marginTop: '8px' }}>
                          <Grid
                            item
                            xs={12}
                            style={{
                              background: theme.palette.text.disabled,
                              justifyContent: 'center',
                              borderTopRightRadius: '8px',
                              borderTopLeftRadius: '8px',
                              height: '40px',
                              display: 'flex',
                              alignItems: 'center'
                            }}
                          >
                            <TextBold
                              style={{
                                lineHeight: '24px',
                                color: theme.palette.text.opposite
                              }}
                            >
                              {item.jobTypeName.toUpperCase()}
                            </TextBold>
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            style={{
                              background: theme.palette.background.default,
                              border: `1px solid ${theme.palette.border.main}`,
                              display: 'flex',
                              borderBottomRightRadius: '8px',
                              borderBottomLeftRadius: '8px',
                              height: 'fit-content',
                              paddingBottom: '16px',
                              flexDirection: 'column',
                              alignItems: 'center'
                            }}
                          >
                            <TextRegular
                              style={{
                                fontSize: '14px',
                                marginTop: '16px',
                                color: theme.palette.text.disabled,
                                lineHeight: '24px'
                              }}
                            >
                              Your referral reward
                            </TextRegular>
                            <TextBold
                              style={{
                                fontSize: '20px',
                                marginTop: '4px',
                                lineHeight: '24px',
                                fontWeight: 800,
                                color: theme.palette.text.success
                              }}
                            >
                              {item.referralRewardType === 'percentage'
                                ? `${item.referralRewardAmount}%`
                                : `${currencySymbol} ${formatNumber(
                                  item.referralRewardAmount
                                )}`}
                            </TextBold>
                            {item.referralRewardType === 'percentage' && (
                              <TextRegular
                                style={{
                                  fontSize: '10px',
                                  textAlign: 'center',
                                  color: theme.palette.text.disabled
                                }}
                              >
                                of base salary
                              </TextRegular>
                            )}
                            {item.referralRewardType === 'hourly' && (
                              <TextRegular
                                style={{
                                  fontSize: '10px',
                                  textAlign: 'center'
                                }}
                              >
                                per hour
                                <br />
                                <span
                                  style={{
                                    color: theme.palette.primary.main
                                  }}
                                >
                                  View payout details
                                </span>
                              </TextRegular>
                            )}
                            {item.referralRewardType !== 'hourly' && (
                              <TextRegular
                                style={{
                                  fontSize: '12px',
                                  marginTop: '4px',
                                  color: theme.palette.text.disabled,
                                  lineHeight: '18px'
                                }}
                              >
                                {item.guaranteePeriod} Days Guarantee Period
                              </TextRegular>
                            )}
                          </Grid>
                        </Grid>
                        <Grid item xs={12}>
                          {(location.pathname === '/recruiter/newsearch' ||
                            location.pathname === '/recruiter/newcompany') && (
                              <>
                                {item?.isInWorklist ? (
                                  <>
                                    <Button
                                      startIcon={
                                        <img
                                          src={appassets.submit}
                                          alt='submit'
                                          style={{ width: 16, height: 16 }}
                                        />
                                      }
                                      variant='outlined'
                                      style={{
                                        textTransform: 'none',
                                        width: '100%',
                                        marginTop: '10px'
                                      }}
                                      onClick={() => {
                                        setPreviewCandidateModal({
                                          open: true,
                                          item: { ...item },
                                          isEdit: false,
                                          onClose: () => {
                                            setPreviewCandidateModal({
                                              open: false,
                                              item: null
                                            })
                                          }
                                        })
                                      }}
                                    >
                                      Submit Candidate
                                    </Button>
                                  </>
                                ) : (
                                  <>
                                    <LightTooltip
                                      title='You can add this job to your worklist. You can then submit resumes of your condidate for this job or share this job on social media or send a referral link to apply for this job to your connections.'
                                      placement='top'
                                    >
                                      <Button
                                        startIcon={
                                          <img
                                            src={`${appassets.addWhite}`}
                                            alt='add'
                                          />
                                        }
                                        variant='contained'
                                        style={{
                                          textTransform: 'none',
                                          width: '100%',
                                          marginTop: '10px'
                                        }}
                                        onClick={() => {
                                          setPreviewModal({
                                            open: true,
                                            button: 'addWorklist',
                                            item: item,
                                            onClose: () => {
                                              setPreviewModal({
                                                open: false
                                              })
                                            }
                                          })
                                        }}
                                      >
                                        Add to worklist
                                      </Button>
                                    </LightTooltip>
                                  </>
                                )}
                              </>
                            )}
                          {location.pathname === '/recruiter/worklist' && (
                            <Button
                              startIcon={
                                <img
                                  src={`${appassets.sendWhite}`}
                                  alt='send'
                                />
                              }
                              variant='contained'
                              style={{
                                textTransform: 'none',
                                width: '100%',
                                marginTop: '10px'
                              }}
                              onClick={() => {
                                setPreviewCandidateModal({
                                  open: true,
                                  item: { ...item },
                                  isEdit: false,
                                  onClose: () => {
                                    setPreviewCandidateModal({
                                      open: false,
                                      item: null
                                    })
                                  }
                                })
                              }}
                            >
                              Submit Candidate
                            </Button>
                          )}

                          {location.pathname === '/recruiter/workedon' &&
                            !(
                              isEmpty(item.facebookLink) &&
                              isEmpty(item.linkedinLink) &&
                              isEmpty(item.twitterLink)
                            ) ? (
                            <Grid container style={{ margin: '24px 17px 0px' }}>
                              <Grid item xs={3}>
                                <TextSemiBold
                                  style={{
                                    fontSize: '16px',
                                    color: theme.palette.text.disabled
                                  }}
                                >
                                  Source:
                                </TextSemiBold>
                              </Grid>

                              {[
                                { icon: appassets.fb, link: item.facebookLink },
                                { icon: appassets.in, link: item.linkedinLink },
                                {
                                  icon: appassets.twitter,
                                  link: item.twitterLink
                                }
                              ].map(row =>
                                row.link ? (
                                  <Link
                                    to={row.link}
                                    target='_blank'
                                    style={{ marginLeft: 16 }}
                                  >
                                    <img
                                      src={row.icon}
                                      alt='icon'
                                      style={{ width: '24px' }}
                                    />
                                  </Link>
                                ) : null
                              )}

                              {/* <Grid
                              item
                              xs={2}
                              style={{
                                display: 'flex',
                                justifyContent: 'center',
                                padding: '0px',
                                marginRight: '4px'
                              }}
                            >
                              <Link
                                to={item.linkedinLink}
                                target='_blank'
                                style={{
                                  pointerEvents: item.linkedinLink
                                    ? 'auto'
                                    : 'none'
                                }}
                              >
                                <img
                                  src={appassets.in}
                                  alt='li'
                                  style={{ width: '24px' }}
                                />
                              </Link>
                            </Grid>

                            <Grid
                              item
                              xs={2}
                              style={{
                                display: 'flex',
                                justifyContent: 'center',
                                padding: '0px',
                                marginRight: '4px'
                              }}
                            >
                              <Link
                                to={item.twitterLink}
                                target='_blank'
                                style={{
                                  pointerEvents: item.twitterLink
                                    ? 'auto'
                                    : 'none'
                                }}
                              >
                                <img
                                  src={appassets.twitter}
                                  alt='twitter'
                                  style={{ width: '24px' }}
                                />
                              </Link>
                            </Grid> */}
                            </Grid>
                          ) : (
                            <></>
                          )}
                        </Grid>
                      </>
                    ) : (
                      <></>
                    )}

                    <Grid
                      container
                      direction={'row'}
                      style={{
                        overflow: 'auto',
                        paddingTop: '12px'
                      }}
                    >
                      <Grid item xs={12} style={{ display: 'flex', }}>
                        <Grid item>
                          <Button
                            variant='text'
                            style={{
                              textTransform: 'none',
                              width: 'max-content',
                              borderBottom: '2px solid'

                            }}
                            onClick={() =>
                              handleIsOpen(item.jobId, 'jobDescription')
                            }
                          >
                            <TextSemiBold
                              style={{
                                // color: theme.palette.text.secondary
                                color: 'black'
                                // isOpen[item.jobId]?.jobDescription === false
                                //   ? theme.palette.text.secondary
                                //   : theme.palette.primary.main
                              }}
                            >
                              Job description
                            </TextSemiBold>
                          </Button>
                          {isOpen[item.jobId]?.jobDescription === true && (
                            <Divider
                              style={{
                                width: '100%',
                                // background: theme.palette.primary.main,
                                height: '2px'
                              }}
                            />
                          )}
                        </Grid>
                        <Grid item>
                          <Button
                            variant='text'
                            style={{
                              textTransform: 'none',
                              width: 'max-content'
                            }}
                            onClick={() =>
                              handleIsOpen(item.jobId, 'Skills')
                            }
                          >
                            <TextSemiBold
                              style={{
                                color: 'black'
                              }}
                            >
                              Skills
                            </TextSemiBold>
                          </Button>
                          {isOpen[item.jobId]?.Skills === true && (
                            <Divider
                              style={{
                                width: '100%',
                                background: theme.palette.primary.main,
                                height: '2px',
                              }}
                            />
                          )}
                        </Grid>
                        <Grid
                          item
                        // style={{ marginRight: '15px' }}
                        >
                          {/* <Badge
                            badgeContent={'New'}
                            color='primary'
                            style={{ fontSize: '8px', zIndex: 0 }}
                          > */}
                          <Button
                            variant='text'
                            style={{
                              textTransform: 'none',
                              width: 'max-content'
                            }}
                            onClick={() =>
                              handleIsOpen(item.jobId, 'employerId')
                            }
                          >
                            <TextSemiBold
                              style={{
                                // color: theme.palette.text.secondary
                                color: 'black'
                              }}
                            >
                              Job Insights
                            </TextSemiBold>
                          </Button>
                          {/* </Badge> */}
                          {isOpen[item.jobId]?.employerId === true && (
                            <Divider
                              style={{
                                width: '100%',
                                background: theme.palette.primary.main,
                                height: '2px'
                              }}
                            />
                          )}
                        </Grid>
                        <Grid item>
                          <Button
                            variant='text'
                            style={{
                              display: 'none',
                              textTransform: 'none',
                              width: 'max-content'
                            }}
                            onClick={() =>
                              handleIsOpen(item.jobId, 'preScreenQuestions')
                            }
                          >
                            <TextSemiBold
                              style={{
                                color: theme.palette.text.secondary
                              }}
                            >
                              Screening Questions
                            </TextSemiBold>
                          </Button>
                          {isOpen[item.jobId]?.preScreenQuestions === true && (
                            <Divider
                              style={{
                                width: '100%',
                                background: theme.palette.primary.main,
                                height: '2px'
                              }}
                            />
                          )}
                        </Grid>
                        <Grid item>
                          <Button
                            variant='text'
                            style={{
                              textTransform: 'none',
                              width: 'max-content'
                            }}
                            onClick={() => handleIsOpen(item.jobId, 'jobTitle')}
                          >
                            <TextSemiBold
                              style={{
                                // color: theme.palette.text.secondary
                                color: 'black'
                              }}
                            >
                              Candidate pipeline
                            </TextSemiBold>
                          </Button>
                          {isOpen[item.jobId]?.jobTitle === true && (
                            <Divider
                              style={{
                                width: '100%',
                                background: theme.palette.primary.main,
                                height: '2px'
                              }}
                            />
                          )}
                        </Grid>

                        {location.pathname === '/recruiter/workedon' && (
                          <Grid item>
                            <Button
                              variant='text'
                              style={{
                                textTransform: 'none',
                                width: 'max-content'
                              }}
                              onClick={() =>
                                setOpenTotalReferral({
                                  open: true,
                                  item: item,
                                  onClose: () => {
                                    setOpenTotalReferral({
                                      open: false
                                    })
                                  }
                                })
                              }
                            >
                              <TextSemiBold
                                style={{
                                  color: theme.palette.text.secondary
                                }}
                              >
                                Total referrals: {item?.applications?.length}
                              </TextSemiBold>
                            </Button>
                          </Grid>
                        )}
                        {location.pathname === '/recruiter/worklist' && (
                          <>
                            <Grid item>
                              <LightTooltip
                                title={`Check here to see if a candidate has already been submitted to ${item?.companyname} through ${ENV.product_name}, Unfortunately, we are only able to check our database. If a candidate already exists in the ${item?.companyname}'s databases, then your submission may not be accepted.`}
                                placement='top'
                              >
                                <Button
                                  variant='text'
                                  style={{
                                    textTransform: 'none',
                                    width: 'max-content'
                                  }}
                                  onClick={() => {
                                    setPreviewModal({
                                      open: true,
                                      button: 'avoideDuplicate',
                                      item,
                                      onClose: () => {
                                        setPreviewModal({
                                          open: false
                                        })
                                      }
                                    })
                                  }}
                                >
                                  <TextSemiBold
                                    style={{
                                      color: theme.palette.text.secondary
                                    }}
                                  >
                                    Avoid Duplicate
                                  </TextSemiBold>
                                </Button>
                              </LightTooltip>
                            </Grid>
                            <Grid item>
                              <Button
                                variant='text'
                                style={{
                                  textTransform: 'none',
                                  width: 'max-content'
                                }}
                                onClick={() => {
                                  setPreviewModal({
                                    open: true,
                                    button: 'removeCandidate',
                                    item,
                                    onClose: isReload => {
                                      if (isReload) {
                                        onReload()
                                      }
                                      setPreviewModal({
                                        open: false
                                      })
                                    }
                                  })
                                }}
                              >
                                <TextSemiBold
                                  style={{
                                    color: theme.palette.text.secondary
                                  }}
                                >
                                  Remove from worklist
                                </TextSemiBold>
                              </Button>
                            </Grid>
                          </>
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>

                {matches ? (
                  <></>
                ) : (
                  <Grid
                    item
                    xs={3}
                    style={{ display: 'flex', justifyContent: 'right' }}
                  >
                    <Grid container spacing={0} style={{ width: '200px' }}>
                      <Grid item xs={12}>
                        <Grid
                          item
                          xs={12}
                          style={{
                            background: theme.palette.text.disabled,
                            justifyContent: 'center',
                            borderTopRightRadius: '8px',
                            borderTopLeftRadius: '8px',
                            height: '40px',
                            display: 'flex',
                            alignItems: 'center'
                          }}
                        >
                          <TextBold
                            style={{
                              lineHeight: '24px',
                              color: theme.palette.text.opposite
                            }}
                          >
                            {item.jobTypeName.toUpperCase()}
                          </TextBold>
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          style={{
                            background: theme.palette.background.default,
                            border: `1px solid ${theme.palette.border.main}`,
                            display: 'flex',
                            borderBottomRightRadius: '8px',
                            borderBottomLeftRadius: '8px',
                            height: 'fit-content',
                            paddingBottom: '16px',
                            flexDirection: 'column',
                            alignItems: 'center'
                          }}
                        >
                          <TextRegular
                            style={{
                              fontSize: '14px',
                              marginTop: '16px',
                              color: theme.palette.text.disabled,
                              lineHeight: '24px'
                            }}
                          >
                            Your referral reward
                          </TextRegular>
                          <TextBold
                            style={{
                              fontSize: '20px',
                              marginTop: '4px',
                              lineHeight: '24px',
                              fontWeight: 800,
                              color: theme.palette.text.success
                            }}
                          >
                            {item.referralRewardType === 'percentage'
                              ? `${item.referralRewardAmount}%`
                              : `${currencySymbol} ${formatNumber(
                                item.referralRewardAmount
                              )}`}
                          </TextBold>
                          {item.referralRewardType === 'percentage' && (
                            <TextRegular
                              style={{
                                fontSize: '10px',
                                textAlign: 'center',
                                color: theme.palette.text.disabled
                              }}
                            >
                              of base salary
                            </TextRegular>
                          )}
                          {item.referralRewardType === 'hourly' && (
                            <TextRegular
                              style={{ fontSize: '10px', textAlign: 'center' }}
                            >
                              per hour
                              <br />
                              <span
                                style={{
                                  color: theme.palette.primary.main
                                }}
                              >
                                View payout details
                              </span>
                            </TextRegular>
                          )}
                          {item.referralRewardType !== 'hourly' && (
                            <TextRegular
                              style={{
                                fontSize: '12px',
                                marginTop: '4px',
                                color: theme.palette.text.disabled,
                                lineHeight: '18px'
                              }}
                            >
                              {item.guaranteePeriod} Days Guarantee Period
                            </TextRegular>
                          )}
                        </Grid>
                      </Grid>

                      <Grid item xs={12}>
                        {(location.pathname === '/recruiter/newsearch' ||
                          location.pathname === '/recruiter/newcompany') && (
                            <>
                              {item?.isInWorklist ? (
                                <>
                                  <Button
                                    startIcon={
                                      <img
                                        src={appassets.submit}
                                        alt='submit'
                                        style={{ width: 16, height: 16 }}
                                      />
                                    }
                                    variant='outlined'
                                    style={{
                                      textTransform: 'none',
                                      width: '100%',
                                      marginTop: '10px'
                                    }}
                                    onClick={() => {
                                      setPreviewCandidateModal({
                                        open: true,
                                        item: { ...item },
                                        isEdit: false,
                                        onClose: () => {
                                          setPreviewCandidateModal({
                                            open: false,
                                            item: null
                                          })
                                        }
                                      })
                                    }}
                                  >
                                    Submit Candidate
                                  </Button>
                                </>
                              ) : (
                                <>
                                  <LightTooltip
                                    title='You can add this job to your worklist. You can then submit resumes of your condidate for this job or share this job on social media or send a referral link to apply for this job to your connections.'
                                    placement='top'
                                  >
                                    <Button
                                      startIcon={
                                        <img
                                          src={`${appassets.addWhite}`}
                                          alt='add'
                                        />
                                      }
                                      variant='contained'
                                      style={{
                                        textTransform: 'none',
                                        width: '100%',
                                        marginTop: '10px'
                                      }}
                                      onClick={() => {
                                        setPreviewModal({
                                          open: true,
                                          button: 'addWorklist',
                                          item: item,
                                          onClose: () => {
                                            setPreviewModal({
                                              open: false
                                            })
                                          }
                                        })
                                      }}
                                    >
                                      Add to worklist
                                    </Button>
                                  </LightTooltip>
                                </>
                              )}
                            </>
                          )}
                        {location.pathname === '/recruiter/worklist' && (
                          <Button
                            startIcon={
                              <img src={`${appassets.sendWhite}`} alt='send' />
                            }
                            variant='contained'
                            style={{
                              textTransform: 'none',
                              width: '100%',
                              marginTop: '10px'
                            }}
                            onClick={() => {
                              setPreviewCandidateModal({
                                open: true,
                                item: { ...item },
                                isEdit: false,
                                onClose: () => {
                                  setPreviewCandidateModal({
                                    open: false,
                                    item: null
                                  })
                                }
                              })
                            }}
                          >
                            Submit Candidate
                          </Button>
                        )}

                        {location.pathname === '/recruiter/workedon' &&
                          !(
                            isEmpty(item.facebookLink) &&
                            isEmpty(item.linkedinLink) &&
                            isEmpty(item.twitterLink)
                          ) ? (
                          <Grid container style={{ margin: '24px 17px 0px' }}>
                            <Grid item xs={3}>
                              <TextSemiBold
                                style={{
                                  fontSize: '16px',
                                  color: theme.palette.text.disabled
                                }}
                              >
                                Source:
                              </TextSemiBold>
                            </Grid>

                            {[
                              { icon: appassets.fb, link: item.facebookLink },
                              { icon: appassets.in, link: item.linkedinLink },
                              {
                                icon: appassets.twitter,
                                link: item.twitterLink
                              }
                            ].map(row =>
                              row.link ? (
                                <Link
                                  to={row.link}
                                  target='_blank'
                                  style={{ marginLeft: 16 }}
                                >
                                  <img
                                    src={row.icon}
                                    alt='icon'
                                    style={{ width: '24px' }}
                                  />
                                </Link>
                              ) : null
                            )}

                            {/* <Grid
                              item
                              xs={2}
                              style={{
                                display: 'flex',
                                justifyContent: 'center',
                                padding: '0px',
                                marginRight: '4px'
                              }}
                            >
                              <Link
                                to={item.linkedinLink}
                                target='_blank'
                                style={{
                                  pointerEvents: item.linkedinLink
                                    ? 'auto'
                                    : 'none'
                                }}
                              >
                                <img
                                  src={appassets.in}
                                  alt='li'
                                  style={{ width: '24px' }}
                                />
                              </Link>
                            </Grid>

                            <Grid
                              item
                              xs={2}
                              style={{
                                display: 'flex',
                                justifyContent: 'center',
                                padding: '0px',
                                marginRight: '4px'
                              }}
                            >
                              <Link
                                to={item.twitterLink}
                                target='_blank'
                                style={{
                                  pointerEvents: item.twitterLink
                                    ? 'auto'
                                    : 'none'
                                }}
                              >
                                <img
                                  src={appassets.twitter}
                                  alt='twitter'
                                  style={{ width: '24px' }}
                                />
                              </Link>
                            </Grid> */}
                          </Grid>
                        ) : (
                          <></>
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                )}
              </Grid>

              {/* Job description */}
              {isOpen[item.jobId]?.jobDescription === true && (
                <Grid
                  container
                  spacing={2}
                  style={{
                    maxHeight: '70vh',
                    overflowY: 'auto',
                    marginTop: '1px'
                  }}
                >
                  <Grid item xs={12}>
                    <Grid
                      item
                      xs={matches ? 12 : 7}
                      style={{
                        border: `1px solid ${theme.palette.primary.main}`,
                        backgroundColor: colorWithOpacity(
                          theme.palette.primary.main,
                          0.1
                        ),
                        borderRadius: '8px',
                        padding: '3px 10px',
                        width: 'fit-content'
                      }}
                    >
                      <TextRegular
                        style={{ color: theme.palette.primary.main }}
                      >
                        <DoDisturbIcon
                          style={{ fontSize: '14px', margin: '-2px 2px' }}
                        />
                        If you post this job on a job board, please do not use
                        company name or salary.
                      </TextRegular>
                    </Grid>
                  </Grid>
                  <Grid item xs={12}>
                    <TextBold
                      style={{
                        fontSize: '18px',
                        lineHeight: '24px',
                        color: theme.palette.primary.main
                      }}
                    >
                      Job Description
                    </TextBold>
                  </Grid>
                  <Grid item xs={12}>
                    <Grid container spacing={1}>
                      <Grid
                        item
                        xs={12}
                        style={{ marginTop: matches ? 0 : '20px' }}
                      >
                        <TextRegular
                          style={{
                            fontSize: '16px'
                          }}
                          dangerouslySetInnerHTML={{
                            __html: item.jobDescription
                          }}
                        />
                      </Grid>
                      {getJobDescriptionData(item)}

                      {/* Visa sponsorship eligibility
                      <Grid item xs={12}>
                        <TextBold
                          style={{
                            fontSize: '16px',
                            lineHeight: '24px',
                            color: theme.palette.text.secondary
                          }}
                        >
                          Visa sponsorship eligibility:
                        </TextBold>
                        <TextRegular
                          style={{
                            fontSize: '16px',
                            lineHeight: '24px',
                            color: theme.palette.text.secondary
                          }}
                        >
                          {' '}
                          {item.visaSponsorship}
                        </TextRegular>
                      </Grid> */}
                      {/* Reports to:
                      <Grid item xs={12}>
                        <TextBold
                          style={{
                            fontSize: '16px',
                            lineHeight: '24px',
                            color: theme.palette.text.secondary
                          }}
                        >
                          Reports to:
                        </TextBold>
                        <TextRegular
                          style={{
                            fontSize: '16px',
                            lineHeight: '24px',
                            color: theme.palette.text.secondary
                          }}
                        >
                          NA
                        </TextRegular>
                      </Grid> */}
                      {/* <Grid item xs={12}>
                      <TextMedium>FLSA:</TextMedium>
                      <TextRegular>  Exempt – Salaried</TextRegular> to-do
                    </Grid>

                    <Grid item xs={12}>
                      <TextMedium>END CLIENT NAME:</TextMedium>
                      <TextRegular> to-do</TextRegular>
                    </Grid> */}
                    </Grid>
                  </Grid>
                </Grid>
              )}
              {isOpen[item.jobId]?.Skills === true && (
                <Grid
                  container
                  spacing={2}
                  style={{
                    maxHeight: '70vh',
                    overflowY: 'auto',
                    marginTop: '1px'
                  }}
                >

                  <Grid item xs={12} style={{ marginTop: "-15px" }}>
                    <Grid container spacing={1}>
                      <Grid
                        item
                        xs={12}
                      // style={{ marginTop: matches ? 0 : '20px' }}
                      >
                        <TextRegular
                          style={{
                            fontSize: '16px'
                          }}
                          dangerouslySetInnerHTML={{
                            __html: item.Skills
                          }}
                        />
                      </Grid>
                      {getSkillsData(item)}
                    </Grid>
                  </Grid>
                </Grid>
              )}
              {/* Job Insights */}
              {isOpen[item.jobId]?.employerId === true && (
                <Grid
                  container
                  spacing={2}
                  style={{
                    maxHeight: '70vh',
                    overflowY: 'auto',
                    marginTop: '1px'
                  }}
                >
                  <Grid item xs={12}>
                    <TextBold
                      style={{
                        fontSize: '18px',
                        lineHeight: '24px',
                        color: theme.palette.primary.main
                      }}
                    >
                      Job Insights
                    </TextBold>
                  </Grid>

                  <Grid item xs={12}>
                    <TextBold
                      style={{
                        fontSize: '18px',
                        lineHeight: '24px',
                        color: theme.palette.text.secondary
                      }}
                    >
                      {'Account manager information: '}
                    </TextBold>
                  </Grid>

                  {getJobInsights(item)}
                </Grid>
              )}

              {/* Screen question */}
              {isOpen[item.jobId]?.preScreenQuestions === true && (
                <Grid
                  container
                  spacing={2}
                  style={{
                    maxHeight: '70vh',
                    overflowY: 'auto',
                    marginTop: '1px',
                    display: 'flex'
                  }}
                >
                  <Grid item xs={11}>
                    <TextBold
                      style={{
                        fontSize: '18px',
                        lineHeight: '24px',
                        color: theme.palette.primary.main
                      }}
                    >
                      Screening Questions
                    </TextBold>
                  </Grid>
                  <Grid item xs={11}>
                    <Grid container spacing={1}>
                      <Grid item xs={12}>
                        {item?.preScreenQuestions?.map((que, index) => (
                          <div>
                            <TextRegular
                              style={{ lineHeight: '24px', fontSize: '16px' }}
                            >{`${index + 1}) ${que.question}`}</TextRegular>
                          </div>
                        ))}
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              )}

              {/* Candidate pipeline */}
              {isOpen[item.jobId]?.jobTitle === true && (
                <Grid
                  container
                  spacing={2}
                  style={{
                    maxHeight: '70vh',
                    overflowY: 'auto',
                    marginTop: '1px',
                    display: 'flex'
                  }}
                >
                  <Grid item xs={12}>
                    <TextBold
                      style={{
                        fontSize: '18px',
                        lineHeight: '24px',
                        color: theme.palette.primary.main
                      }}
                    >
                      Candidate Pipeline
                    </TextBold>
                  </Grid>
                  <Grid item xs={12} style={{ justifyContent: 'center' }}>
                    <Divider
                      sx={{
                        position: 'relative',
                        top: '40px',
                        left: 'calc(9%)',
                        width: '82%'
                      }}
                    />
                    <Box
                      display='flex'
                      alignItems={'baseline'}
                      width={'100%'}
                      padding={'20px 0px'}
                    >
                      {[
                        {
                          label: 'Open Position',
                          count: item.totalPositions - item.closedPositions
                        },
                        {
                          label: 'Under client review',
                          count: item?.candidatePipeline?.underClientReview
                        },
                        {
                          label: 'Hiring manager review',
                          count:
                            item?.candidatePipeline?.underHiringManagerReview
                        },
                        {
                          label: 'Interview stage',
                          count: item?.candidatePipeline?.interviewStage
                        },
                        {
                          label: 'Offer stage',
                          count: item?.candidatePipeline?.offerStage
                        },
                        {
                          label: 'Rejected',
                          count:item?.candidatePipeline?.rejected
                          // count: item?.candidatePipeline?.rejected
                          // item.totalPositions - item.closedPositions
                        }
                      ].map((item, index) => (
                        <Box
                          key={index}
                          textAlign={'center'}
                          flex={1}
                          position={'relative'}
                        >
                          <Typography variant='body1'>
                            <Box
                              width={40}
                              height={40}
                              borderRadius={'50%'}
                              backgroundColor={
                                item.count > 0
                                  ? theme.palette.primary.main
                                  : theme.palette.background.default
                              }
                              color={
                                item.count > 0
                                  ? theme.palette.text.opposite
                                  : theme.palette.text.secondary
                              }
                              display={'flex'}
                              alignItems={'center'}
                              justifyContent={'center'}
                              margin={'0px auto'}
                              style={{ position: 'relative', zIndex: 1 }}
                            >
                              {item.count}
                            </Box>
                          </Typography>
                          <Typography variant='body2' marginTop={'8px'}>
                            {item.label}
                          </Typography>
                        </Box>
                      ))}
                    </Box>
                  </Grid>
                </Grid>
              )}
            </Paper>
          </Grid>
        ))
      ) : (
        <NoRecordFound />
      )}
      {previewModal?.open && (
        <WorklistModal data={previewModal} matches={matches} />
      )}
      {previewCandidateModal?.open && (
        <CandidateFormModal data={previewCandidateModal} matches={matches} />
      )}
      {openTotalReferral?.open && (
        <TotalReferralsModal data={openTotalReferral} matches={matches} />
      )}
    </Grid>
  )
}

export default JobPost
